/**
 * Enum for dependency action codes.
 */
export enum EnumDepActionCodes {

  /**
   * Value action.
   */
  Value = 'val',
  /**
   * Text replace action.
   */
  TextReplace = 'repl',
  /**
   * Calculation action.
   */
  Calculation = 'calc'
}
